import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=eddace1a&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eddace1a')) {
      api.createRecord('eddace1a', component.options)
    } else {
      api.reload('eddace1a', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=eddace1a&", function () {
      api.rerender('eddace1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2RmR2VfPmcnHT/JS/videoIframe.vue"
export default component.exports